export default __webpack_public_path__ + "static/media/upwork.95959be3.svg";